import {
  MarketplaceServer,
  InitiateConnectResponse,
  ConnectStatusResponse,
} from '@/types/api';
import { getApiBaseUrl, handleResponse } from './client';

const API_URL = getApiBaseUrl();

/** List all remote MCP servers in the marketplace catalog */
export async function getMarketplaceServers(): Promise<MarketplaceServer[]> {
  const response = await fetch(`${API_URL}/mcp/marketplace/servers`);
  return handleResponse<MarketplaceServer[]>(response);
}

/** Get details for a single marketplace server */
export async function getMarketplaceServer(
  id: string,
): Promise<MarketplaceServer> {
  const response = await fetch(`${API_URL}/mcp/marketplace/servers/${id}`);
  return handleResponse<MarketplaceServer>(response);
}

/**
 * Initiate the OAuth flow for a remote MCP server.
 * Returns the authorization URL that the frontend should open in the browser.
 */
export async function initiateConnect(
  marketplaceId: string,
): Promise<InitiateConnectResponse> {
  const response = await fetch(`${API_URL}/mcp/marketplace/connect`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ marketplaceId }),
  });
  return handleResponse<InitiateConnectResponse>(response);
}

/**
 * Poll the connection status for a marketplace server.
 * The frontend polls this while waiting for the OAuth callback to complete.
 */
export async function getConnectStatus(
  marketplaceId: string,
): Promise<ConnectStatusResponse> {
  const response = await fetch(
    `${API_URL}/mcp/marketplace/connect/status/${marketplaceId}`,
  );
  return handleResponse<ConnectStatusResponse>(response);
}